
export default function SkillsSection() {
  const skillCategories = [
    {
      title: 'Competências Técnicas',
      icon: 'ri-tools-line',
      skills: [
        { name: 'Planejamento e Controle da Produção', level: 95 },
        { name: 'Gestão de Projetos', level: 90 },
        { name: 'Análise de Processos', level: 88 },
        { name: 'Segurança do Trabalho', level: 85 },
        { name: 'Controle de Qualidade', level: 92 }
      ]
    },
    {
      title: 'Ferramentas & Software',
      icon: 'ri-computer-line',
      skills: [
        { name: 'Revit / BIM', level: 88 },
        { name: 'Excel Avançado', level: 95 },
        { name: 'KPI e Senior Sistemas', level: 85 },
        { name: 'Power BI', level: 80 },
        { name: 'AutoCAD', level: 82 }
      ]
    }
  ];

  const certifications = [
    {
      title: 'Engenharia Civil',
      institution: 'Centro Universitário Integrado',
      year: '2022',
      icon: 'ri-graduation-cap-line'
    },
    {
      title: 'Especialização, Engenharia e Segurança no Trabalho',
      institution: 'Centro Universitário Integrado',
      year: '2024',
      icon: 'ri-award-line'
    },
    {
      title: 'Técnico, Segurança no Trabalho',
      institution: 'Unicesumar',
      year: '2025',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
            Competências & <span className="text-yellow-600">Ferramentas</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Domínio técnico e ferramental necessário para entregar soluções de excelência.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {skillCategories.map((category, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-8">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4">
                  <i className={`${category.icon} text-xl text-yellow-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{category.title}</h3>
              </div>

              <div className="space-y-6">
                {category.skills.map((skill, idx) => (
                  <div key={idx}>
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-medium text-gray-900">{skill.name}</span>
                      <span className="text-sm text-gray-600">{skill.level}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-gradient-to-r from-yellow-500 to-yellow-600 h-2 rounded-full transition-all duration-1000"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div>
          <h3 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Formação & <span className="text-yellow-600">Certificações</span>
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${cert.icon} text-2xl text-yellow-600`}></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{cert.title}</h4>
                <p className="text-yellow-600 font-medium mb-1">{cert.institution}</p>
                <p className="text-gray-600 text-sm">{cert.year}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
